<template>
    <div>
        <div class="select-wrapper" v-for="select in selects" :key="select.id">
            <div
                style="
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 14px;
                    margin-bottom: 5px;
                "
            >
                {{ select.label }}
            </div>
            <BaseSelect
                :default-title="select.value || select.placeholder"
                :options="select.options"
                :isMultiple="false"
                is-close-after-check
                is-full-width
                @check="onSelectAction($event)"
            />
        </div>
    </div>
</template>

<script>
import BaseSelect from "../../../Base/BaseSelectMultipleV2.vue";

export default {
    components: {
        BaseSelect
    },

    props: {
        selects: {
            type: Array,
            default: () => [],
        },
    },

    methods: {
        onSelectAction(option) {
            this.$emit("onSelectAction", option);
        }
    },
};
</script>

<style lang="scss" scoped>
.select-wrapper {
    margin-bottom: 20px;

    &:last-child {
        margin-bottom: 0;
    }
}
</style>
